import { combineReducers } from 'redux';
import { viewStates } from './App/appViewStates';
import { entities } from './App/appEntities';
import { LOGOUT } from './App/Login/loginActions';

export const appReducer = combineReducers({
    entities,
    viewStates
});

export const rootReducer = (state, action) => {
    if (action.type === LOGOUT) {
        state = undefined;
    }

    return appReducer(state, action);
};
